module.exports = __webpack_public_path__ + "img/International.beccd561.svg";